import {
  formatFullDateTime,
  formatRelativeTime,
} from '../registry/internals/localTime';
import { useMinuteTick } from '../registry/internals/useMinuteTick';
import { useTimeFormat } from '../registry/internals/useTimeFormat';

export const FeedAge = ({ at }: { at: string | null }) => {
  useMinuteTick(at !== null);
  const prefer12Hr = useTimeFormat();
  if (!at) return null;
  return (
    <time dateTime={at} title={formatFullDateTime(at, prefer12Hr)}>
      {formatRelativeTime(at)}
    </time>
  );
};
